module.exports = __webpack_public_path__ + "img/westrock-logo.1761ce78.jpg";